import { gql, useLazyQuery } from "@apollo/client";
export const GET_STUDY_LIST = gql`
  query getKarapitStudyList($username: String!, $encryptedPassword: String!) {
    getKarapitStudyList(
      input: { username: $username, encryptedPassword: $encryptedPassword }
    )
  }
`;

export function useGetKarapitStudyList() {
  const [
    getKarapitStudyList,
    { data: studyList, loading: isLoadingStudyList, error: errorStudyList }
  ] = useLazyQuery(GET_STUDY_LIST);
  return {
    getKarapitStudyList,
    studyList,
    isLoadingStudyList,
    errorStudyList
  };
}
